<template>
    <component :is="to ? NuxtLink : as" v-bind="to ? { to } : {}" :class="ui.root()">
        <slot name="icon" />

        <span :class="ui.label()">
            {{ label }}
        </span>

        <slot />
    </component>
</template>

<script setup lang="ts">
    import { NuxtLink } from '#components';

    import {
        SidebarNavItemVariants,
        type SidebarNavItemVariant
    } from '@/assets/css/themes/custom-components/constants/sidebar-nav-item';

    const props = defineProps({
        label: {
            type: String,
            required: true
        },
        to: {
            type: [String, Object]
        },
        as: {
            type: String,
            default: 'span'
        },
        active: {
            type: Boolean
        },
        variant: {
            type: String as PropType<SidebarNavItemVariant>,
            default: SidebarNavItemVariants.Link
        }
    });

    const ui = useComponentUi('sidebarNavItem', () => ({
        variant: props.variant,
        active: props.active
    }));
</script>
